export default __webpack_public_path__ + "static/media/headlight-icon.5ac16e1a.png";